<template>
  <div class="two-menu-page">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "twoMemuBox",
};
</script>

<style lang="scss" scoped>
.two-menu-page {
  width: 100%;
  height: 100%;
}
</style>